import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: 'yu0d0be7',
    dataset: 'production',
})